import * as React from 'react';
import { useState } from 'react';
import { Button, Modal, notification } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { useAtomValue } from 'jotai';
import { queryClientAtom } from 'jotai-tanstack-query';
import axiosApiInstance from '../../../api/axiosClient';

type Props = {
    creatorId: number;
    onRefreshStarted?: () => void;
};

const RefreshCreator = (props: Props) => {
    const queryClient = useAtomValue(queryClientAtom);
    const [loading, setLoading] = useState(false);

    const handleClick = () => {
        let creatorName = 'this creator';
        axiosApiInstance
            .get(`/api/creators/items/${props.creatorId}`)
            .then(({ data }) => {
                creatorName = data?.creator ?? creatorName;
            })
            .catch(() => undefined)
            .finally(() => {
                Modal.confirm({
                    title: 'Refresh creator data?',
                    content: `Fetch latest followers, Instagram engagement rate, profile info, and audience demographics for "${creatorName}". This can take a few minutes.`,
                    okText: 'Refresh',
                    cancelText: 'Cancel',
                    onOk: async () => {
                        setLoading(true);
                        try {
                            await axiosApiInstance.post(`/api/creators/items/${props.creatorId}/refresh`);
                            await queryClient.invalidateQueries({ queryKey: ['creators', String(props.creatorId)] });
                            props.onRefreshStarted?.();
                            notification.success({
                                message: 'Refresh started',
                                description: 'Profile, IG engagement rate, and demographics are updating. Instagram charts refresh automatically.',
                                duration: 4,
                            });
                        } catch (error: any) {
                            notification.error({
                                message: 'Error',
                                description: error?.response?.data?.error ?? 'Failed to refresh creator details.',
                            });
                        } finally {
                            setLoading(false);
                        }
                    },
                });
            });
    };

    return (
        <Button
            icon={<ReloadOutlined />}
            loading={loading}
            onClick={handleClick}
            style={{
                borderRadius: 8,
                fontWeight: 500,
                boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
            }}
        >
            Refresh
        </Button>
    );
};

export default RefreshCreator;
